<template>
  <span>
    <button type="button" class="btn btn-outline-primary" :disabled="!model || !model.country_code" @click="visible=true">Calendrier de référence</button>
    <b-modal v-model="visible" title="Calendrier de référence" size="xl" scrollable hide-footer>
      <p><strong>{{ model && model.country_name }}</strong> · Pays paramétré pour l’établissement</p>
      <label for="vac-reference-profile">Profil de la référence</label>
      <select id="vac-reference-profile" v-model="profile" class="form-control mb-3">
        <option value="child">Enfant / adolescente</option><option value="pregnancy">Femme enceinte</option><option value="adult">Adulte</option>
      </select>
      <div v-if="reference">
        <h3 class="h5">{{ reference.title }}</h3>
        <p class="reference-source">{{ reference.source.title }} · {{ reference.source.edition ? 'Édition '+reference.source.edition : 'Édition non indiquée sur le document' }}</p>
        <p class="reference-notice">{{ reference.notice }}</p>
        <div class="table-responsive">
          <table class="table"><caption class="sr-only">{{ reference.title }}</caption>
            <thead><tr><th scope="col">Âge / échéance indiqué</th><th scope="col">Vaccins / doses</th><th scope="col">{{ profile==='pregnancy' ? 'Protection indiquée sur l’affiche' : 'Autres interventions (hors vaccins)' }}</th><th scope="col">Conditions / observations</th></tr></thead>
            <tbody><tr v-for="(row,index) in reference.rows" :key="index"><td>{{ row.when }}</td><td>{{ row.vaccines.join(' + ') || '—' }}</td><td>{{ profile==='pregnancy' ? row.protection : (row.other_interventions || []).join(' + ') || '—' }}</td><td>{{ row.conditions || '—' }}</td></tr></tbody>
          </table>
        </div>
        <a v-if="sourceUrl(reference.source.document)" :href="sourceUrl(reference.source.document)" target="_blank" rel="noopener noreferrer">Consulter le document source (nouvel onglet)</a>
      </div>
      <p v-else class="alert alert-info" role="status">Aucune référence documentée pour ce profil et ce pays. Le calendrier d’un autre pays n’est pas appliqué.</p>
      <p class="reference-notice mt-3">Référence documentaire, pas une prescription. Les échéances individuelles éventuelles sont présentées séparément dans le suivi confirmé du patient. Aucun rattrapage ni envoi de rappel automatique. Vérifier le protocole applicable et l’historique avant l’administration.</p>
      <div class="ui-modal-actions"><button type="button" class="btn btn-outline-secondary" @click="visible=false">Fermer</button></div>
    </b-modal>
  </span>
</template>
<script>
export default {
  props:{model:{type:Object,default:null},contextKey:{type:[String,Number],default:''}},
  data:()=>({visible:false,profile:'child'}),
  computed:{reference(){return (this.model && this.model.references && this.model.references[this.profile]) || null}},
  watch:{contextKey(){this.visible=false;this.profile='child'},model(value){if(!value)this.visible=false}},
  methods:{sourceUrl(value){
    if(['references/vaccination/benin-enfant-mars-2026.pdf','references/vaccination/benin-femme-enceinte.pdf'].includes(value))return (process.env.BASE_URL || '/')+value;
    if(typeof value!=='string' || !/^https:\/\//i.test(value) || /[\s\\]/.test(value))return null;
    try{const url=new URL(value);return url.protocol==='https:' && !url.username && !url.password ? url.href : null}catch(e){return null}
  }}
}
</script>
<style scoped>
label{font-weight:600;color:var(--ui-text-secondary,#273449)}
.form-control{min-height:44px;border:1px solid #9aaac1;border-radius:14px;color:var(--ui-text,#172033)}
.reference-source{font-size:13px;color:var(--ui-text-muted,#526074)}
.reference-notice{padding:12px;background:#f2f6fd;border-radius:12px;color:var(--ui-text-secondary,#273449)}
.table th,.table td{color:var(--ui-text-secondary,#273449);vertical-align:top}
.btn{border-radius:999px;min-height:44px}
</style>
